import { render } from "./ArchiveHeader.vue?vue&type=template&id=cf35db9a&scoped=true"
import script from "./ArchiveHeader.vue?vue&type=script&lang=js"
export * from "./ArchiveHeader.vue?vue&type=script&lang=js"

import "./ArchiveHeader.vue?vue&type=style&index=0&id=cf35db9a&lang=scss&scoped=true"

import exportComponent from "E:\\uni-app项目\\kxsns-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf35db9a"]])

export default __exports__